<template>
        <b-modal  id="modal-content-video"
          :hide-footer="true" 
          :hide-header="true" 
          :centered="true">
          <b-icon class="close"  icon="x" aria-hidden="true" @click="closeModal"></b-icon>
          <!--/////////////////// esto no se si es un video o un iframe ////////////////////////////////// -->
          <!-- <video  controls>
            <source src="movie.mp4" type="video/mp4">
            <source src="movie.ogg" type="video/ogg">
          Your browser does not support the video tag.
          </video> -->
          <iframe width="560" height="315" :src="urlVideo" :title="$t('title.4')"
           frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
           allowfullscreen></iframe>
          </b-modal>
</template>
<script>
export default {
  data(){
    return{
      isCloseModal:true
    }
  },
  props: {
    urlVideo :{
      type: String
    }
	},
  methods:{
    closeModal(){
      this.isCloseModal=false,
      this.$emit('valueClose', {flag: this.isCloseModal, urlVideo:this.urlVIdeo })
      this.$bvModal.hide('modal-content-video')
    }
  }
}
</script>